import _ from 'lodash'
import React from 'react'
import viewliftLogo from '~/assets/images/viewlift-logo.png'
import './Footer01.css'

import appStore from '~/assets/images/app-store-badge.svg'
import playStore from '~/assets/images/google-play-badge.png'
import rokuStore from '~/assets/images/roku.png'
import chromecastStore from '~/assets/images/chromecast.png'
import fireTv from '~/assets/images/amazon-app-store.png'
import { localizeTitle } from '~/tools/localization'

const getBadgeSrc = url => {
  if (url.includes('apple.com')) 
    return appStore
  if (url.includes('chromecast')) 
    return chromecastStore
  if (url.includes('google.com')) 
    return playStore
  if (url.includes('roku')) 
    return rokuStore
  if (url.includes('amazon.com'))
    return fireTv
}

// hacky way to remove poweredByVIEWLIFT for be-at.tv
const keepPowerBySection = window.settings.internalName.includes('be-at') ? false: true;

class Footer01 extends React.Component {
  constructor(){
    super()
    this.state= {
      footerPusher: 0
    }
    this.setFooterHeight = this.setFooterHeight.bind(this)
  }
  componentDidMount(){
    this.setFooterHeight()
    window.addEventListener('resize', this.setFooterHeight);
  }

  setFooterHeight(){
    this.setState({
      footerPusher: document.querySelector('.footer01__content').clientHeight + 30
    });
  }
  renderAppLinks() {
    const appLinks = _.get(window.settings, 'navigation.appStore')
    if (!appLinks)
      return

    return _.map(appLinks, (link, index) => {
      let linkBgStyle = { 
        background: `url(${getBadgeSrc(link.url)}) no-repeat`, 
        backgroundSize: 'contain', 
        backgroundPosition: 'center' 
      }

      return <a style={linkBgStyle} className='app-link' key={index} href={link.url} target='_blank'/>
    });
  }

  render() {
    const links = _.get(window.settings, 'navigation.footer')
    const socialLinks = _.pickBy(_.get(window.settings, 'socialMedia'), link => link.url)
    const sponsors = _.get(window.settings, 'navigation.sponsor')
    const networkItems = _.get(window.settings, 'navigation.network');
    if (!window.sessionStorage.getItem('isApp')){
    return <div className='footer01'>
        <div className='footer01__pusher' style={{height: `${this.state.footerPusher}px`}}/>
        <div className='footer01__content footer'>
          <div className='footer01__border site-border-color' />
          <div className='links'>
            {_.map(links, (l, i) => (
              <a className='link' href={l.url} target={l.newTab ? "_blank" : "_self"} key={i}>
                {localizeTitle(l)}
              </a>
            ))}

            <div className='social-links'>
              {_.map(socialLinks, (sl, k) => (
                <a
                  key={k}
                  href={sl.url}
                  target='_blank'
                  className={`connect-circle ${k}`}
                >
                  <span className={`ion-social-${k}`} />
                </a>
              ))}
            </div>
          </div>

          <div className='app-links'>{this.renderAppLinks()}</div>

          {sponsors && <div className='sponsor-links'>
              {_.map(sponsors, (sl, k) => (
                <a
                  key={k}
                  href={sl.url}
                  target='_blank'
                  className={`sponsor-link`}
                >
                  <img src={sl.icon} className='sponsor-img' alt={sl.title} />
                </a>
              ))}
            </div>}

          <div className='info'>
            <div className='copyright'>
              {`© ${new Date().getFullYear()} ${
                window.settings.companyName
              }. ALL RIGHTS RESERVED.`}
            </div>
            {keepPowerBySection && <div className='powered-by'>
              <a target='_blank' href='http://www.viewlift.com/'>
                Powered by
                {!window.SERVER_SIDE_RENDERING && <img src={viewliftLogo} alt='ViewLift' />}
              </a>.
            </div>}
          </div>
          {networkItems && <div className='network-links'>
              {_.map(networkItems, (nl, k) => (
                <a
                  key={k}
                  href={nl.url}
                  target='_blank'
                  className={`network-link`}
                >
                  <img src={nl.icon} className='network-img' alt={nl.title}/>
                </a>
              ))}
            </div>}
        </div>
      </div>;} else {
      return (<div></div>)
    }
  }
}

export default Footer01
